module.exports = __webpack_public_path__ + "img/item6.4b09e070.png";